import React, { useEffect, useRef } from 'react';
import { ADMIN_STEP_IDS } from './types/adminOnboarding.types';

// Import step components
import WelcomeStep from './steps/WelcomeStep';
import CompanyTopicsStep from './steps/CompanyTopicsStep';
import LectureInfoStep from './steps/LectureInfoStep';
import TermsStep from './steps/TermsStep';

// Step component mapping
const STEP_COMPONENTS = {
  [ADMIN_STEP_IDS.WELCOME]: WelcomeStep,
  [ADMIN_STEP_IDS.COMPANY_TOPICS]: CompanyTopicsStep,
  [ADMIN_STEP_IDS.LECTURE_INFO]: LectureInfoStep,
  [ADMIN_STEP_IDS.TERMS]: TermsStep
};

export default function AdminOnboardingStepRenderer({ 
  activeStepId, 
  onStepComplete, 
  onStepChange, 
  companyId,
  isStepCompleted 
}) {
  const stepContentRef = useRef(null);
  const StepComponent = STEP_COMPONENTS[activeStepId];

  // Scroll to top when step changes
  useEffect(() => {
    if (stepContentRef.current) {
      stepContentRef.current.scrollTo(0, 0);
    }
  }, [activeStepId]);

  // Fallback if step component not found
  if (!StepComponent) {
    return (
      <div className="text-center p-4">
        <h5>Schritt wird geladen...</h5>
        <p>Schritt "{activeStepId}" ist noch nicht implementiert.</p>
      </div>
    );
  }

  return (
    <div ref={stepContentRef} className="step-content d-flex flex-column h-100">
      <StepComponent 
        onComplete={onStepComplete}
        onStepChange={onStepChange}
        stepId={activeStepId}
        companyId={companyId}
        isCompleted={isStepCompleted}
      />
    </div>
  );
}